import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createCancelablePromise, TimeoutTimer } from '../../../base/common/async.js';
import { Emitter } from '../../../base/common/event.js';
import { Disposable, MutableDisposable } from '../../../base/common/lifecycle.js';
import { Range } from '../../common/core/range.js';
import { CodeActionProviderRegistry } from '../../common/modes.js';
import { RawContextKey } from '../../../platform/contextkey/common/contextkey.js';
import { Progress } from '../../../platform/progress/common/progress.js';
import { getCodeActions } from './codeAction.js';
import { isEqual } from '../../../base/common/resources.js';
export var SUPPORTED_CODE_ACTIONS = new RawContextKey('supportedCodeAction', '');

var CodeActionOracle = /*#__PURE__*/function (_Disposable) {
  _inherits(CodeActionOracle, _Disposable);

  var _super = _createSuper(CodeActionOracle);

  function CodeActionOracle(_editor, _markerService, _signalChange) {
    var _this;

    var _delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 250;

    _classCallCheck(this, CodeActionOracle);

    _this = _super.call(this);
    _this._editor = _editor;
    _this._markerService = _markerService;
    _this._signalChange = _signalChange;
    _this._delay = _delay;
    _this._autoTriggerTimer = _this._register(new TimeoutTimer());

    _this._register(_this._markerService.onMarkerChanged(function (e) {
      return _this._onMarkerChanges(e);
    }));

    _this._register(_this._editor.onDidChangeCursorPosition(function () {
      return _this._onCursorChange();
    }));

    return _this;
  }

  _createClass(CodeActionOracle, [{
    key: "trigger",
    value: function trigger(_trigger) {
      var selection = this._getRangeOfSelectionUnlessWhitespaceEnclosed(_trigger);

      return this._createEventAndSignalChange(_trigger, selection);
    }
  }, {
    key: "_onMarkerChanges",
    value: function _onMarkerChanges(resources) {
      var _this2 = this;

      var model = this._editor.getModel();

      if (!model) {
        return;
      }

      if (resources.some(function (resource) {
        return isEqual(resource, model.uri);
      })) {
        this._autoTriggerTimer.cancelAndSet(function () {
          _this2.trigger({
            type: 1
            /* Auto */

          });
        }, this._delay);
      }
    }
  }, {
    key: "_onCursorChange",
    value: function _onCursorChange() {
      var _this3 = this;

      this._autoTriggerTimer.cancelAndSet(function () {
        _this3.trigger({
          type: 1
          /* Auto */

        });
      }, this._delay);
    }
  }, {
    key: "_getRangeOfMarker",
    value: function _getRangeOfMarker(selection) {
      var model = this._editor.getModel();

      if (!model) {
        return undefined;
      }

      var _iterator = _createForOfIteratorHelper(this._markerService.read({
        resource: model.uri
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var marker = _step.value;
          var markerRange = model.validateRange(marker);

          if (Range.intersectRanges(markerRange, selection)) {
            return Range.lift(markerRange);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return undefined;
    }
  }, {
    key: "_getRangeOfSelectionUnlessWhitespaceEnclosed",
    value: function _getRangeOfSelectionUnlessWhitespaceEnclosed(trigger) {
      if (!this._editor.hasModel()) {
        return undefined;
      }

      var model = this._editor.getModel();

      var selection = this._editor.getSelection();

      if (selection.isEmpty() && trigger.type === 1
      /* Auto */
      ) {
        var _selection$getPositio = selection.getPosition(),
            lineNumber = _selection$getPositio.lineNumber,
            column = _selection$getPositio.column;

        var line = model.getLineContent(lineNumber);

        if (line.length === 0) {
          // empty line
          return undefined;
        } else if (column === 1) {
          // look only right
          if (/\s/.test(line[0])) {
            return undefined;
          }
        } else if (column === model.getLineMaxColumn(lineNumber)) {
          // look only left
          if (/\s/.test(line[line.length - 1])) {
            return undefined;
          }
        } else {
          // look left and right
          if (/\s/.test(line[column - 2]) && /\s/.test(line[column - 1])) {
            return undefined;
          }
        }
      }

      return selection;
    }
  }, {
    key: "_createEventAndSignalChange",
    value: function _createEventAndSignalChange(trigger, selection) {
      var model = this._editor.getModel();

      if (!selection || !model) {
        // cancel
        this._signalChange(undefined);

        return undefined;
      }

      var markerRange = this._getRangeOfMarker(selection);

      var position = markerRange ? markerRange.getStartPosition() : selection.getStartPosition();
      var e = {
        trigger: trigger,
        selection: selection,
        position: position
      };

      this._signalChange(e);

      return e;
    }
  }]);

  return CodeActionOracle;
}(Disposable);

export var CodeActionsState;

(function (CodeActionsState) {
  CodeActionsState.Empty = {
    type: 0
    /* Empty */

  };

  var Triggered = function Triggered(trigger, rangeOrSelection, position, actions) {
    _classCallCheck(this, Triggered);

    this.trigger = trigger;
    this.rangeOrSelection = rangeOrSelection;
    this.position = position;
    this.actions = actions;
    this.type = 1
    /* Triggered */
    ;
  };

  CodeActionsState.Triggered = Triggered;
})(CodeActionsState || (CodeActionsState = {}));

export var CodeActionModel = /*#__PURE__*/function (_Disposable2) {
  _inherits(CodeActionModel, _Disposable2);

  var _super2 = _createSuper(CodeActionModel);

  function CodeActionModel(_editor, _markerService, contextKeyService, _progressService) {
    var _this4;

    _classCallCheck(this, CodeActionModel);

    _this4 = _super2.call(this);
    _this4._editor = _editor;
    _this4._markerService = _markerService;
    _this4._progressService = _progressService;
    _this4._codeActionOracle = _this4._register(new MutableDisposable());
    _this4._state = CodeActionsState.Empty;
    _this4._onDidChangeState = _this4._register(new Emitter());
    _this4.onDidChangeState = _this4._onDidChangeState.event;
    _this4._supportedCodeActions = SUPPORTED_CODE_ACTIONS.bindTo(contextKeyService);

    _this4._register(_this4._editor.onDidChangeModel(function () {
      return _this4._update();
    }));

    _this4._register(_this4._editor.onDidChangeModelLanguage(function () {
      return _this4._update();
    }));

    _this4._register(CodeActionProviderRegistry.onDidChange(function () {
      return _this4._update();
    }));

    _this4._update();

    return _this4;
  }

  _createClass(CodeActionModel, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(CodeActionModel.prototype), "dispose", this).call(this);

      this.setState(CodeActionsState.Empty, true);
    }
  }, {
    key: "_update",
    value: function _update() {
      var _this5 = this;

      this._codeActionOracle.value = undefined;
      this.setState(CodeActionsState.Empty);

      var model = this._editor.getModel();

      if (model && CodeActionProviderRegistry.has(model) && !this._editor.getOption(72
      /* readOnly */
      )) {
        var supportedActions = [];

        var _iterator2 = _createForOfIteratorHelper(CodeActionProviderRegistry.all(model)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var provider = _step2.value;

            if (Array.isArray(provider.providedCodeActionKinds)) {
              supportedActions.push.apply(supportedActions, _toConsumableArray(provider.providedCodeActionKinds));
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this._supportedCodeActions.set(supportedActions.join(' '));

        this._codeActionOracle.value = new CodeActionOracle(this._editor, this._markerService, function (trigger) {
          var _a;

          if (!trigger) {
            _this5.setState(CodeActionsState.Empty);

            return;
          }

          var actions = createCancelablePromise(function (token) {
            return getCodeActions(model, trigger.selection, trigger.trigger, Progress.None, token);
          });

          if (trigger.trigger.type === 2
          /* Manual */
          ) {
            (_a = _this5._progressService) === null || _a === void 0 ? void 0 : _a.showWhile(actions, 250);
          }

          _this5.setState(new CodeActionsState.Triggered(trigger.trigger, trigger.selection, trigger.position, actions));
        }, undefined);

        this._codeActionOracle.value.trigger({
          type: 1
          /* Auto */

        });
      } else {
        this._supportedCodeActions.reset();
      }
    }
  }, {
    key: "trigger",
    value: function trigger(_trigger2) {
      if (this._codeActionOracle.value) {
        this._codeActionOracle.value.trigger(_trigger2);
      }
    }
  }, {
    key: "setState",
    value: function setState(newState, skipNotify) {
      if (newState === this._state) {
        return;
      } // Cancel old request


      if (this._state.type === 1
      /* Triggered */
      ) {
        this._state.actions.cancel();
      }

      this._state = newState;

      if (!skipNotify) {
        this._onDidChangeState.fire(newState);
      }
    }
  }]);

  return CodeActionModel;
}(Disposable);